export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const RESTAURANT = {
  name: "Sri Dosa Express",
  phone: "732-318-6284",
  phoneHref: "tel:+17323186284",
  address1: "1700 Oak Tree Rd Unit 6",
  address2: "Edison, NJ 08820",
  mapEmbed:
    "https://maps.google.com/maps?q=1700%20Oak%20Tree%20Rd%20Unit%206%2C%20Edison%2C%20NJ%2008820&t=&z=15&ie=UTF8&iwloc=&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=1700+Oak+Tree+Rd+Unit+6+Edison+NJ+08820",
};

export const LINKS = {
  uberEats: "https://www.ubereats.com/store/sri-dosa-express-inside-desi-galaxy-express-edison/bo5W003VSy-G2rAjwYuDuw",
  doorDash: "https://www.doordash.com/search/store/?query=Sri%20Dosa%20Express",
  instagram: "https://www.instagram.com/sridosaexpress/",
  facebook: "https://www.facebook.com/sridosaexpress",
};

export const px = (id, w = 1260, h = 750) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}&h=${h}&dpr=1`;

export const pxFree = (id, w = 900) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const IMG = {
  heroFallback: px(20422121, 1920, 1080),
  heroGenerated: "/images/hero-tawa.png",
  interiorGenerated: "/images/interior.png",
  aboutChef: px(36630804, 1000, 1250),
  aboutSpread: pxFree(35539315, 1000),
  cateringBanquet: px(8818741, 1400, 900),
  cateringFeast: px(5410418, 1000, 700),
  categories: {
    dosas: "/images/dishes/ghee-masala-dosa.jpg",
    idlis: "/images/dishes/idli.jpg",
    vadas: px(20422135),
    uttapam: px(36854500),
    breakfast: px(14831540),
    biryani: px(30748997),
    friedRice: px(7593230),
    noodles: "/images/dishes/veg-noodles.jpg",
    chaats: "/images/dishes/chat.jpg",
    snacks: px(941869),
    kids: px(20689305),
    desserts: px(15014918),
    beverages: px(9619560),
  },
  gallery: [
    { src: "/images/interior.png", label: "The Dining Room" },
    { id: 20422131, label: "Signature Masala Dosa" },
    { id: 20422133, label: "Golden Triangle Dosa" },
    { id: 20422121, label: "Cone Dosa" },
    { id: 20422132, label: "Medu Vada & Sambar" },
    { id: 35539324, label: "South Indian Thali" },
    { id: 5410418, label: "Festive Banana-Leaf Feast" },
    { id: 15014919, label: "Gulab Jamun" },
    { id: 5560763, label: "Dosas on Banana Leaf" },
    { id: 8887054, label: "Jalebi & Brass Sweets" },
    { id: 20422126, label: "Chutney Flight" },
    { id: 12392923, label: "Breakfast & Chai" },
    { id: 20408455, label: "The Morning Spread" },
  ],
};

export const EVENT_TYPES = [
  "Wedding Catering",
  "Birthday Parties",
  "Housewarming",
  "Corporate Events",
  "Temple Events",
  "Festivals",
  "Private Parties",
];
